import { cn, getRoleLabel } from '@/lib/utils';

const roleStyles = {
  admin: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  hr: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  controller: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  employee: 'bg-slate-500/20 text-slate-400 border-slate-500/30',
};

export default function RoleBadge({ role, className }) {
  return (
    <span 
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold uppercase tracking-wide",
        roleStyles[role] || roleStyles.employee,
        className
      )}
      data-testid={`role-badge-${role}`}
    >
      {getRoleLabel(role)}
    </span>
  );
}
